import { utils } from 'apprise-core/utils'
import * as React from 'react'


export type Placeholder = 'none' | 'list' | 'empty' | 'error'

export type WaitIndicatorProps = React.PropsWithChildren<{

    context: string
    waiting: boolean
    msg: React.ReactNode
    noBleed: boolean

    style: React.CSSProperties

}>

export type DialogProps = {
    title: string,
    msg: string,
    okLabel: string
    onOk: (close: () => void) => void,
    canceLabel: string
    onCancel: () => void
}


export type Bridge = {

    placeholder: Partial<Record<Placeholder, React.ReactNode>>

    renderError: (_: Error, msg?: string, rethrow?: boolean) => any

    renderDialog: (_: Partial<DialogProps>) => void

    Indicator: (_: Partial<WaitIndicatorProps>) => JSX.Element

}




export const initialComponentBridge: Bridge = {


    placeholder: {

        none: null,
        list: <><li>waiting...</li><li>waiting...</li></>,
        error: <div>something is wrong.</div>,
        empty: 'no data'

    }

    ,

    renderError: (e: Error, msg?: string, rethrow: boolean = true) => {

        alert(`${msg ?? e.message}${e["details"] ? `\n\n  ${e["details"]}` : ''}`)

        if (rethrow)
            throw e

    }

    ,

    renderDialog: ({ msg, onOk } = {}) => {

        if (window.confirm(msg))
            onOk?.(()=>{})

    }

    ,

    Indicator: props => {

        const { waiting, msg, noBleed, children, style } = props
        const overlay: React.CSSProperties = { position: noBleed ? 'absolute' : 'fixed', background: "#fdfdfde0", zIndex: 9999, display: "flex", height: "100%", width: "100%", alignItems: "center", justifyContent: "center" }

        return <div style={{ ...style, position: "relative" }}>
            {waiting && <div style={overlay}><div>{msg ?? 'loading...'}</div></div>}
            {children}
        </div>

    }    



}



export type ComponentBridgeProps = React.PropsWithChildren<{

    bridge?: Partial<Bridge>
}>


const ComponentBridgeContext = React.createContext<Bridge>(initialComponentBridge)

//  intent-revealing wrapper
export const useComponentBridge = () => React.useContext(ComponentBridgeContext) ?? initialComponentBridge

//  overlays application's bridge over default one, the propagates down in context. 
export const ComponentBridge = (props: ComponentBridgeProps) => {

    const { bridge: clientBridge = {}, children } = props

    const bridge = utils().merge(initialComponentBridge, clientBridge)

    return <ComponentBridgeContext.Provider value={bridge}>
        {children}
    </ComponentBridgeContext.Provider>

}

